import http from "@/api/http.js";

export function getProductsVariations(unificado) {
  return http
    .get(`/products_variations/single_product/${unificado}`)
    .then(res => {
      return res;
    })
    .catch(e => {
      throw e;
    });
}

export function productVariationDelete(unificado) {
  return http
    .delete(`products_variations/delete_product?unificado=${unificado}`)
    .then(res => {
      return res;
    })
    .catch(e => {
      throw e;
    });
}

export function productVariationInsert(unificado, unificadoVariation) {
  return http
    .post(`products_variations/new_relation`, {
      relation: {
        unificado: unificado,
        unificado_related: unificadoVariation
      }
    })
    .then(res => {
      return res;
    })
    .catch(e => {
      throw e;
    });
}
